import {Logger} from "../../modules/common/log";
import {TumboEdidSearch} from "../../modules/edid/TumboEdidSearch";
import {initNamespace} from "../../modules/common/main/MainTumboApplication";

initNamespace();

/**
 * Inits the EDID search app, given the localization and configuration objects
 * @param localizationDictionary {object} The localization dictionary
 * @param edidSearchConfiguration {object} The configuration object
 * @param targetElementId {string} The id of the div element where to render the app into
 * @param debug {boolean} if true, the app will log debug messages
 */
function initEdidSearch(localizationDictionary, edidSearchConfiguration, targetElementId, debug) {
    const edidSearch = new TumboEdidSearch(localizationDictionary, edidSearchConfiguration, targetElementId, new Logger(!!debug));
    edidSearch.loadConfig();
    edidSearch.run();
}

/**
 * Inits the EDID search app, given the localization and configuration services URLs
 * @param localizationDictionaryUrl {string} The localization service URL
 * @param edidSearchConfigurationUrl {string} The configuration service URL
 * @param targetElementId {string} The id of the div element where to render the app into
 * @param debug {boolean} if true, the app will log debug messages
 */
function initEdidSearchFromUrls(localizationDictionaryUrl, edidSearchConfigurationUrl, targetElementId, debug) {
    $.ajax({
        url: edidSearchConfigurationUrl
    }).done(function (mapConfiguration) {
        $.ajax({
            url: localizationDictionaryUrl
        }).done(function (localizationDictionary) {
            if (Object.prototype.toString.call(localizationDictionary) === '[object String]') {
                localizationDictionary = JSON.parse(localizationDictionary);
            }
            initEdidSearch(localizationDictionary, mapConfiguration, targetElementId, debug);
        });
    });
}

window.tumbo.initEdidSearch = initEdidSearch;
window.tumbo.initEdidSearchFromUrls = initEdidSearchFromUrls;
export {initEdidSearch, initEdidSearchFromUrls}